import { IQuery, IModel, IQueryMediator } from 'core-ts-types';
import { ORMMediator } from 'utility-ts-datasource';
import { ISectionAvailabilityDatasource } from '../../../views/sections/datasources/section_availability_datasource';
import { ISectionsDatasource } from '../../../views/sections/datasources/sections_datasource';
import { ILocationsDatasource } from '../../../views/sections/datasources/locations_datasource';
import { ICampusesDatasource } from '../../../views/sections/datasources/campuses_datasource';
import { ISectionTimesDatasource } from '../../../views/sections/datasources/section_times_datasource';
import {
  ISection,
  ISectionTime,
  IRawLocation,
  ILocation,
  ITermCourse,
  ICourse
} from '../../../interfaces/scheduler_interfaces';
import { ITermSectionTypesDatasource } from '../../../views/term_courses/datasources/term_section_types_datasource';
import * as _4 from 'lodash4';
import { ITermCoursesDatasource } from '../../../views/term_courses/datasources/term_courses_datasource';
import { LinkedSectionsModel } from '../../../views/sections/models/linked_sections_model';
import { CRNSearchModel } from '../models/crn_search_model';
import { Section } from '../../../views/sections/builders/section_builder';
const UN_PLANNED_COURSE_ID = -1;
interface ICourseSections {
  sections: ISection[];
  course: ITermCourse | {};
}
export class CRNSearchResultsQuery implements IQuery {
  private _result: {
    courseSections: ICourseSections[];
    shouldShowRefineSearchWarning: boolean;
  };

  constructor(
    private ngCRNSearchModel: CRNSearchModel,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngTermCoursesDatasource: ITermCoursesDatasource
  ) {
    ORMMediator.registerQuery(this, ngCRNSearchModel);
  }

  clear() {
    this._result = {
      courseSections: [],
      shouldShowRefineSearchWarning: false
    };
  }

  run() {
    const { sectionIds } = this.ngCRNSearchModel.read();
    const { unPlannedCourseIds, totalMatchCount } = this.ngCRNSearchModel.read();
    const sectionsInfowithMetaInfo = _4.compact(
      _4.map(sectionIds, (sectionId) => {
        const section = this.ngSectionsDatasource.get(sectionId);
        if (section) {
          return this.ngSectionsDatasource.metasource().compose(section);
        } else {
          return;
        }
      })
    ) as Section[];

    const sectionsGroupedbyCourse = _4.groupBy(sectionsInfowithMetaInfo, 'course');

    const courseSectionsData: ICourseSections[] = [];
    for (const key in sectionsGroupedbyCourse) {
      courseSectionsData.push({
        course: this.ngTermCoursesDatasource.get(key) || {},
        sections: sectionsGroupedbyCourse[key]
      });
    }

    const courseSections = _4.map(courseSectionsData, (courseSection: ICourseSections): ICourseSections => {
      courseSection.course['isPlannedCourse'] = !_4.includes(
        unPlannedCourseIds,
        _4.get(courseSection, 'course.id', UN_PLANNED_COURSE_ID)
      );
      return courseSection;
    });
    const shouldShowRefineSearchWarning = _4.gt(totalMatchCount, 20);

    this._result = {
      courseSections,
      shouldShowRefineSearchWarning
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngCRNSearchResultsQuery', CRNSearchResultsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/crn_search/queries/crn_search_query.ts